import { SpinResponse } from '@cgs/data-access';
import { Container } from '@cgs/wge';
import { ResponseHolder } from '../response_holder';
import { BaseGameState } from './base_game_state';
import { SLOT_MACHINE_STORE_TOKEN, SlotMachineStore } from '../../../store';

export class SlotMachineStoreState<
  TResponse extends SpinResponse,
> extends BaseGameState<TResponse> {
  public skipNetworkRequest: boolean = false;
  protected readonly slotMachineStore: SlotMachineStore;

  constructor(container: Container, responseHolder: ResponseHolder<TResponse>, id: string) {
    super(responseHolder, id);

    this.slotMachineStore = container.resolve<SlotMachineStore>(SLOT_MACHINE_STORE_TOKEN);
  }

  public override async onEnterImpl(): Promise<void> {
    super.onEnterImpl();

    if (this.skipNetworkRequest) {
      return;
    }

    const spinResponse = await this.slotMachineStore.stream.toPromise();

    this.responseHolder.preResponse = this.responseHolder.curResponse;
    this.responseHolder.curServerResponse = spinResponse as TResponse;
  }

  public override onLeaveImpl(): void {
    this.skipNetworkRequest = false;
    super.onLeaveImpl();
  }
}
